import { saveAs } from 'file-saver';
import { IFileService } from '../models/interfaces/file.interface';

export class FileService implements IFileService {
    downloadBlob(blob: Blob, filename: string): void {
        saveAs(blob, filename);
    }
}
